import BaseIncomingPayload from "./base-incoming-payload.ts";
import IncomingPayloadEvent from "../../enums/incoming-payload-event.ts";
import Group from "../../models/group.ts";
import User from "../../models/user.ts";
import ParseUtils from "../../utils/parse-utils.ts";

export default class V1GroupJoined extends BaseIncomingPayload {
  public readonly payload: V1GroupJoinedPayload;

  constructor(payload: Record<string, unknown>) {
    super(payload, IncomingPayloadEvent.V1_GROUP_JOINED);

    this.payload = new V1GroupJoinedPayload(ParseUtils.parseObject(payload, "payload"));
  }
}

export class V1GroupJoinedPayload {
  public readonly group: Group;
  public readonly user: User;

  constructor(payload: Record<string, unknown>) {
    this.group = Group.fromPayload(ParseUtils.parseObject(payload, "group"));
    this.user = User.fromPayload(ParseUtils.parseObject(payload, "user"));
  }
}
